import { connect } from 'react-redux';

import HomeDateTimePicker from '../../components/HomeDateTimePicker';

import {
  requestFulfillmentTimes,
  setHomeFulfillmentTime,
  toggleDateTimeModal,
  hideLogisticsModals,
} from '../../actions/homeFeedActions';

import {
  trackViewedDeliveryTimePicker,
  trackChangedDeliveryTime,
} from '../../actions/tracking/filters';

import {
  getFulfillmentDay,
  getFulfillmentTime,
  getIsAsapUnavailable,
  buildFulfillmentDayOptions,
  buildFulfillmentTimeOptionsMap,
} from '../../selectors/homeSelectors';
import { isFeatureActive } from '../../selectors/configSelectors';
import { CO_CLICK_AND_COLLECT } from '../../flags/features';

const mapStateToProps = (state) => ({
  fulfillmentDay: getFulfillmentDay(state),
  fulfillmentTime: getFulfillmentTime(state),
  fulfillmentDayOptions: buildFulfillmentDayOptions(state),
  fulfillmentTimeOptionsMap: buildFulfillmentTimeOptionsMap(state),
  withClickAndCollect: isFeatureActive(state, CO_CLICK_AND_COLLECT),
  isAsapUnavailable: getIsAsapUnavailable(state),
});

const mapDispatchToProps = (dispatch) => ({
  requestFulfillmentTimes: () => dispatch(requestFulfillmentTimes()),
  setHomeFulfillmentTime: (fulfillmentTime) =>
    Promise.all([
      dispatch(trackChangedDeliveryTime('restaurant list')),
      dispatch(setHomeFulfillmentTime({ fulfillmentTime })),
    ]),
  onOpen: () => dispatch(trackViewedDeliveryTimePicker('restaurant list')),
  onClose: () => {
    dispatch(toggleDateTimeModal(false));
    window.scrollTo(0, 0);
  },
  onConfirm: () => dispatch(hideLogisticsModals()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeDateTimePicker);
